import React from 'react'

import {
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem,
  EuiSpacer
} from '@elastic/eui'

import alexaCardImage from "images/Products/Alexa/instar-alexa-9008.webp"
import homekitCardImage from "images/Products/Homekit/INSTAR-HomeKit-HomeApp.webp"

import HomekitFlyout from './HomekitFlyout'
import AlexaFlyout from './AlexaFlyout'

export default function WebUIArticles() {

  return (
    <React.Fragment>
      <EuiFlexItem>
        <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                  <img
                    src={alexaCardImage}
                    alt="INSTAR Alexa Camera Skill"
                  />
              }
              title='Alexa Camera Skill'
              description={
                <p>Activate camera control for your IN-9408 or IN-9420 2k+ WQHD through Alexa using your free INSTAR Cloud account.</p>
              }
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                    <EuiFlexItem grow={false}>
                      <AlexaFlyout />
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                  <img
                    src={homekitCardImage}
                    alt="INSTAR Kamera Homekit Support"
                  />
              }
              title='Apple Homekit'
              description={
                <p>Control your INSTAR 2k+ WQHD camera with the Apple Homekit app from your iPhone or iPad.</p>
              }
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                    <EuiFlexItem grow={false}>
                      <HomekitFlyout />
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>
    </React.Fragment>
  );
}
